import { render, staticRenderFns } from "./InformationDetails.vue?vue&type=template&id=7be0cdb6&"
import script from "./InformationDetails.vue?vue&type=script&lang=js&"
export * from "./InformationDetails.vue?vue&type=script&lang=js&"
import style0 from "./InformationDetails.vue?vue&type=style&index=0&id=7be0cdb6&prod&lang=css&"
import style1 from "./InformationDetails.vue?vue&type=style&index=1&id=7be0cdb6&prod&lang=css&"
import style2 from "./InformationDetails.vue?vue&type=style&index=2&id=7be0cdb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports